import {ArrowNarrowLeftIcon} from '@heroicons/react/solid';
import type {JSX} from 'react';
import {useNavigate} from 'react-router-dom';

import Spinner from '@/assets/svg/Spinner';
import {Header} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import Detail from '@/components/transactions/Detail';
import TransactionHistory from '@/components/transactions/History';

import useTransactionDetailsPage from './useTransactionDetailsPage';

export default function TransactionDetailsPage(): JSX.Element {
  const navigate = useNavigate();
  const {
    transactionDetail,
    transactionHistory,
    totalTransactions,
    loadingTnxDetail,
    loadingTnxHistory,
    loadingExport,
    onExport,
    historyPage,
    handleHistoryPageChange,
  } = useTransactionDetailsPage();
  return (
    <div className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        title="Transaction Details"
        icon={
          <ArrowNarrowLeftIcon
            className="font-light w-5 h-5 text-black dark:text-white hover:text-indigo-500 dark:hover:text-indigo-500 cursor-pointer"
            onClick={() => navigate(-1)}
            data-cy="admin-transaction-details-back"
          />
        }
      />

      <div className="flex justify-center items-center flex-col">
        {loadingTnxDetail ? (
          <Spinner size={8} className="text-cyan-600" />
        ) : (
          <div
            className="mt-10 w-10/12 rounded-md bg-white dark:bg-gray-900 border border-gray-300 p-7 flex flex-col dark:border-dark-borderHeavy"
            data-cy="admin-transaction-details"
          >
            {transactionDetail && <Detail data={transactionDetail} />}
          </div>
        )}

        {/* Always mounted, with the table owning its loading state: keeping
            it (and its pagination footer) mounted across page fetches stops
            `Pagination` remounting, whose mount effect fires
            `onPageChange({page: 0})` and would snap the view back to page 1. */}
        <div
          className="mt-5 w-10/12 rounded-md bg-white dark:bg-gray-900 border border-gray-300 p-7 flex flex-col dark:border-dark-borderHeavy"
          data-cy="admin-transaction-history"
        >
          <TransactionHistory
            data={transactionHistory}
            handleExport={onExport}
            loadingExport={loadingExport}
            totalTransactions={totalTransactions}
            isLoading={loadingTnxHistory}
            page={historyPage}
            onPageChange={
              handleHistoryPageChange as PaginationProps['onPageChange']
            }
          />
        </div>
      </div>
    </div>
  );
}
